export default "__VITE_ASSET__k6Ggtdow__"